export const server = "production";

const UAT = {
  API_ENDPOINT_URL: "https://uat2.accruebenefits.com",
  AwsBucket: "accrue-uat",
  CloudFrontUrl: "https://d2t3ubjf6740pz.cloudfront.net",
  API_SWAGGER: "https://performance-service-admin-uat.accruebenefits.com",
  API_SWAGGER_INCENTIVE: "https://incentive-service-uat.accruebenefits.com",
  API_SWAGGER_ATTENDANCE: "https://attendance-manager-uat.accruebenefits.com",
  API_SWAGGER_CHECKLISTS: "https://checklist-service-uat.accruebenefits.com",
  API_SERVICEDESK: "https://helpdeskuat.accrue.club",
  API_ASSET_MANAGER: "https://asset-manager-uat.accruebenefits.com",
  API_SWAGGER_E_LESARNING_SERVICE:
    "https://elearning-service-uat.accruebenefits.com",
  API_COPILOT_SERVICE: "https://copilot-service-uat.accruebenefits.com",
  API_AWS_FILE_UPLOAD: "https://app-home-dev.accruebenefits.com/home/upload",
  API_KEY: "429765A4-B5CF-48FB-A164-4E388870777C",
  WEB_APP_URL: "https://uatweb.accrue.club/learn",
};

const production = {
  API_ENDPOINT_URL: "https://api.accruebenefits.com",
  AwsBucket: "accrue-prod",
  CloudFrontUrl: "https://d1zgru07h1f99f.cloudfront.net",
  API_SWAGGER: "https://performance-service-admin.accruebenefits.com",
  API_SWAGGER_INCENTIVE: "https://incentive-service-prod.accruebenefits.com",
  API_SWAGGER_ATTENDANCE: "https://attendance-manager-prod.accruebenefits.com",
  API_SWAGGER_CHECKLISTS: "https://checklist-service-prod.accruebenefits.com",
  API_SERVICEDESK: "https://helpdeskprod.accrue.club",
  API_ASSET_MANAGER: "https://asset-manager-prod.accruebenefits.com",
  API_SWAGGER_E_LESARNING_SERVICE:
    "https://elearning-service-prod.accruebenefits.com",
  API_COPILOT_SERVICE: "https://copilot-service-prod.accruebenefits.com",
  API_AWS_FILE_UPLOAD: "https://app-home-prod.accruebenefits.com/home/upload",
  API_KEY: "C6C15788-E4DA-4366-B29F-2C05E5789870",
  WEB_APP_URL: "https://www.accrue.club/learn",
};

const config = () => {
  switch (server) {
    case "UAT":
      return UAT;
    case "production":
      return production;
    default:
      return UAT;
  }
};

export const api = config();
